import type { CmsTier, Tier } from "../../types";
import nameLevels from "./nameLevels";
import type { Action } from "./types";

const transformTier = (
  prevTier: Tier[],
  cmsTiers: Record<string, CmsTier>,
): Tier[] => {
  const list = Object.keys(cmsTiers).map((key) => cmsTiers[key]); // My tiers
  if (!list || !list?.length) {
    return prevTier;
  }

  const ret = new Map<string | undefined, Tier>();

  for (const n of prevTier)
    if (n?.id)
      ret.set(n.id, {
        ...n,
      });

  for (const cms of list) {
    if (!cms?.id) continue;
    if (ret.get(cms.id)) {
      const ob = ret.get(cms.id);
      ret.set(cms.id, {
        ...ob,
        ...cms,
        milestones: nameLevels(ob?.milestones, cms.levels),
        hasCms: true,
      } as Tier);
    } else {
      ret.set(cms.id, {
        ...cms,
        hasCms: true,
      } as Tier);
    }
  }

  const retValue = [...ret.values()];
  return retValue;
};

const loadTiersConfiguration: Action<"tiersConfigurationLoaded"> = (
  state,
  msg,
  payload,
) => {
  const tiers = msg?.tiers?.tiers || {};
  return {
    ...state,
    tiers: transformTier(state.tiers, tiers),
    head: {
      ...state.head,
      links: msg.tiers?.links,
    },
  };
};

export default loadTiersConfiguration;
